import { styled } from "@material-ui/core";

export const PRICE_LIST_CELL_INPUT_CLASS = "priceList-cell-input";

/**
 * Wrapper for an always-visible inline input inside a price-list table cell.
 *
 * Why a wrapper: the input itself is sized to fit the column, but we still
 * want a comfortable 44px tap target (a11y) for users on touch devices. The
 * wrapper stretches into the row's vertical padding so the hit area extends
 * around the input without making the row taller.
 */
export const CenteredInputBox = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  margin: theme.spacing(-0.5, 0),
  width: "100%",
  "& .MuiTextField-root, & .MuiOutlinedInput-root, & .MuiInputBase-root": {
    width: "100%",
  },
  // Zero the root container's own horizontal padding so the inner input
  // can use the full column width. (MUI's marginDense default is 8px 16px
  // on .MuiOutlinedInput-root, which on narrow columns squashes the
  // centred value into nothing.)
  "& .MuiOutlinedInput-root, & .MuiInputBase-root": {
    paddingLeft: 0,
    paddingRight: 0,
  },
  "& .MuiOutlinedInput-input, & .MuiInputBase-input, & .MuiSelect-select": {
    textAlign: "center",
    padding: theme.spacing(0.5),
    // Match the surrounding cell typography (MUI v4 TableCell uses body2,
    // 0.875rem) — by default MUI inputs render at body1 / 1rem, which made
    // editable cells visibly larger than read-only ones in the same row.
    fontSize: theme.typography.body2.fontSize,
    // Inputs under 16px make mobile browsers pinch-zoom the page on focus,
    // so give up the cell-matching size on phones.
    [theme.breakpoints.down("xs")]: {
      fontSize: 16,
    },
  },
}));

/**
 * For read-only cells (e.g. org-owned rows that the user can't edit) — keeps
 * the visual rhythm with the editable cells: centred text inside the column.
 */
export const CenteredReadOnlyValue = styled("div")(({ theme }) => ({
  textAlign: "center",
  padding: theme.spacing(1),
  color: theme.palette.text.secondary,
}));
